import Resource from '@/plugins/sdk/Resource'
import resources from '@/plugins/sdk/resources/index'
import Request, { GET } from '@/plugins/sdk/Request'
import find from 'lodash/find'
import get from 'lodash/get'
import hasIn from 'lodash/hasIn'

export default class {
  constructor () {
    Object.defineProperties(this, {
      $resources: {
        configurable: false,
        enumerable: false,
        value: Object.freeze(resources),
        writable: false
      }
    })

    return new Proxy(Object.freeze(this), {
      get (api, property) {
        if (hasIn(api, property)) {
          return get(api, property)
        }

        return find(api.$resources, ['name', property])
      }
    })
  }

  static install (Vue) {
    Object.defineProperty(Vue.prototype, '$sdk', { value: new this() })
  }

  checkResource (resource) {
    if (resource instanceof Resource) {
      return resource
    }

    if (typeof resource === 'string') {
      const r = this[resource]

      if (r && r.prototype instanceof Resource) {
        return r
      }
    }

    return false
  }

  async search (query, resource, callback, abortSignal, newSearch, limit) {
    const results = []
    const request = Object.assign(new Request(), {
      method: GET,
      _pathname: 'search'
    })

    if (query) {
      request.filters = { q: query, newSearch: Boolean(newSearch), limit: limit || 20 }
    }

    if (resource) {
      if (resource instanceof Resource) {
        resource = resource.constructor.name
      } else if (resource.prototype instanceof Resource) {
        resource = resource.name
      }

      request.filters = { resource }
    }

    if (typeof callback === 'function') {
      await Promise.resolve(callback(request))
    }

    let response = await fetch(await request.build(), { signal: abortSignal })

    if (response.ok) {
      response = await response.json()

      for (let result of response.data.searches) {
        resource = this[result.resource.split('.').join('_')]

        /* eslint-disable new-cap */
        const r = new resource()
        r.fill(result[result.resource], true)
        results.push(r)
      }
    }

    return results
  }
}
